import Program from "wwg-utilities/dist/collections/program";
import getMapString from "wwg-utilities/dist/sharedFunctions/getMapString";

interface MapProps {
    program: Program;
}

const Map: React.FC<MapProps> = ({ program }) => {
    return (
        <section className="px-4 my-8 lg:px-0">
            <iframe
                width="100%"
                height="400px"
                src={`https://www.google.com/maps/embed/v1/place?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
                    }&q=${decodeURI(getMapString(program))}`}
            ></iframe>
        </section>
    );
};

export default Map;